import ad from "../images/SkillSVGs/ant-design.svg"
import wpfxaml from "../images/SkillSVGs/xaml.svg"
import apisvg from "../images/SkillSVGs/api.svg"
import atlassian from "../images/SkillSVGs/atlassian.svg"
import awsAmplify from "../images/SkillSVGs/aws-amplify.svg"
import awsDynamo from "../images/SkillSVGs/aws-dynamodb.svg"
import aws from "../images/SkillSVGs/aws.svg"
import database from "../images/SkillSVGs/database.svg"
import map from "../images/SkillSVGs/map.svg"
import powershell from "../images/SkillSVGs/powershell.svg"
import access from "../images/SkillSVGs/ms-access.svg"

export const skillsData = {
  skillsData: [
    {
      name: "React",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      alias: "React, ReactJS, React.js",
    },
    {
      name: "Vue",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      alias: "Vue, VueJS, vue.js",
    },
    {
      name: "Angular",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      alias: "Angular JS, AngularJS, Angular.js, Angular",
    },
    {
      name: "Redux",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      alias: "react-redux, redux-saga",
    },
    {
      name: "Babel",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/babel/babel-original.svg",
      alias: "babel, babel.js",
    },
    {
      name: "Web Services",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg",
      alias: "Amazon Web Services",
    },
    {
      name: "Apache",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg",
      alias: "Apache",
    },
    {
      name: "Windows",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/windows8/windows8-original.svg",
      alias: "Windows OS, Windows Server",
    },
    {
      name: "Android",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
      alias: "Android",
    },
    {
      name: "Apple",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg",
      alias: "Apple, Mac, MAC OSx",
    },
    {
      name: "Azure",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
      alias: "Azure",
    },

    {
      name: "Chrome",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/chrome/chrome-original.svg",
      alias: "Google Chrome, Browser",
    },
    {
      name: "CodeIgniter",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/codeigniter/codeigniter-plain.svg",
      alias: "codeigniter, php framework",
    },
    {
      name: "Confluence",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/confluence/confluence-original.svg",
      alias: "Confluence",
    },
    {
      name: "C++",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      alias: "C Plus Plus, C, C++",
    },
    {
      name: "Microsoft .Net",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dot-net/dot-net-original.svg",
      alias: ".Net, C#.net, asp.net",
    },
    {
      name: ".Net Core",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg",
      alias: "Net Core, Core 3.0",
    },
    {
      name: "Figma",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      alias: "UX Tool, UI Desiging",
    },
    {
      name: "Google",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
      alias: "Google",
    },
    {
      name: "GraphQL",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
      alias: "Graph QL, GraphQL",
    },
    {
      name: "Jenkins",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
      alias: "Jenkins, pipelines, deployment, CI/CD",
    },
    {
      name: "Jira",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg",
      alias: "Jira",
    },
    {
      name: "less",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/less/less-plain-wordmark.svg",
      alias: "less css",
    },
    {
      name: "Material UI",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg",
      alias: "MUI, Material, UI",
    },
    {
      name: "Markdown",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/markdown/markdown-original.svg",
      alias: "Moodle",
    },
    {
      name: "Nuget",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nuget/nuget-original.svg",
      alias: "Nuget",
    },
    {
      name: "Putty",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/putty/putty-original.svg",
      alias: "Putty",
    },
    {
      name: "Raspberrypi",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/raspberrypi/raspberrypi-original.svg",
      alias: "Raspberry pi",
    },
 

    {
      name: "Sass",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg",
      alias: "Sass, css",
    },

    {
      name: "ThreeJS",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original.svg",
      alias: "three.js, 3.js, 3, Three",
    },
    {
      name: "Trello",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain.svg",
      alias: "Trello",
    },
    {
      name: "TypeScript",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      alias: "Type Script, TS",
    },
    {
      name: "Unity",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/unity/unity-original.svg",
      alias: "Unity",
    },
    {
      name: "Webpack",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/webpack/webpack-original.svg",
      alias: "Webpack",
    },

    {
      name: "Xamarin",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/xamarin/xamarin-original.svg",
      alias: "xamarin",
    },
    {
      name: "Ant Design",
      icon: ad,
      alias: "Ant, AntD, AntDesign",
    },
    {
      name: "Javascript",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      alias: "JS, JavaScript, Vanilla JS, Vanilla, vanilla.js",
    },
    {
      name: "API",
      icon: apisvg,
      alias: "API, api development",
    },
    {
      name: "C# .Net",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dot-net/dot-net-original.svg",
      alias: "CS, CSharp, C-Sharp",
    },
    {
      name: "Atlassian",
      icon: atlassian,
      alias: "Jira, Bit-Bucket, Confluence, Trello",
    },
    {
      name: "Bit Bucket",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bitbucket/bitbucket-original.svg",
      alias: "Bit-Bucket",
    },
    {
      name: "WPF / XAML",
      icon: wpfxaml,
      alias: "Windows Presentation Foundation, WPF, XAML",
    },
    {
      name: "jQuery",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-original.svg",
      alias: "JQuery",
    },
    {
      name: "HTML",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg",
      alias: "HTML, HTML5",
    },
    {
      name: "Node JS",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      alias: "Node, Node.js, NodeJS",
    },
    {
      name: "Photoshop",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/photoshop/photoshop-plain.svg",
      alias: "PS, Photo-Shop",
    },
    {
      name: "PHP",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
      alias: "PHP",
    },
    {
      name: "MS SQL Sever",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain-wordmark.svg",
      alias: "MS-SQL, MS SQL Server",
    },
    {
      name: "PostgreSQL",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      alias: "Postgre-sql, Postgres",
    },

    {
      name: "Powershell",
      icon: powershell,
      alias: "CMD, Command Prompt, Windows Powershell, Terminal",
    },
    {
      name: "Visual Studio",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/visualstudio/visualstudio-plain.svg",
      alias: "VS, VS2019, VS2016",
    },
    {
      name: "Bootstrap",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      alias: "Bootstrap",
    },
    {
      name: "MySQL",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg",
      alias: "My-SQL",
    },
    {
      name: "MongoDB",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      alias: "Mongo, Mongo-DB, mongo db",
    },
    {
      name: "Git",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      alias: "git, github",
    },

    {
      name: "CSS",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg",
      alias: "CSS, CSS3",
    },
    {
      name: "Tailwind",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg",
      alias: "TailwindCSS, tailwind css",
    },
    {
      name: "Databases",
      icon: database,
      alias: "DB, RDBMS, Database, Relational Database",
    },
    {
      name: "Dynamo DB",
      icon: awsDynamo,
      alias: "DynamoDB",
    },
    {
      name: "Express",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      alias: "ExpressJS, Express.js",
    },
    {
      name: "Nest JS",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-plain.svg",
      alias: "NestJS, Nest.js",
    },
    {
      name: "Amplify",
      icon: awsAmplify,
      alias: "AWS Amplify",
    },
    {
      name: "MapObjects",
      icon: map,
      alias: "ArcView, MapObjects 2.0",
    },
    {
      name: "Gatsby",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gatsby/gatsby-original.svg",
      alias: "GatsbyJS, Gatsby.js",
    },
    {
      name: "Docker",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      alias: "Docker",
    },
    {
      name: "Kubernetes",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      alias: "Kubernetes",
    },
    {
      name: "MS Access",
      icon: access,
      alias: "Microsoft Access, Access, MSAcess",
    },
    {
      name: "NPM",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg",
      alias: "NPM, Node Package Manager",
    },
    {
      name: "Studio Code",
      icon:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      alias: "VSC, Visual Studio Code",
    },
    {
      name: "Amazon AWS",
      icon: aws,
      alias: "AWS",
    },
  ],
}
